<!--  -->
<template>
  <div>
    <el-form
      :label-position="'right'"
      label-width="100px"
      :model="productInfo"
    >
      <el-form-item label="商品名称">
        <el-input
          v-model="productInfo.name"
          placeholder="前端展示名称，最大6位字符"
          maxlength="6"
          class="idwewr"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="商品金额">
        <el-input
          v-model="productInfo.price"
          placeholder="请输入商品金额"
          class="idwewr"
        ></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="获得金币数">
        <el-input
          class="idwewr"
          disabled
          v-model="scrollWrapper"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="赠送金币数">
        <el-input
          class="idwewr"
          v-model="productInfo.price"
          placeholder="赠送金币数，可为0，最大不得超过999999"
          maxlength="999999"
        ></el-input>
      </el-form-item>
      <el-form-item label="底部提示">
        <el-input
          v-model="productInfo.footTip"
          placeholder="前端展示名称，最大10位字符"
          maxlength="10"
          class="idwewr"
        ></el-input>
      </el-form-item>
      <el-form-item label="角标文案">
        <el-input
          v-model="productInfo.cornerTip"
          placeholder="角标文案，最大6位字符"
          maxlength="6"
          class="idwewr"
        ></el-input>
      </el-form-item>
      <el-form-item label="手势引导">
        <el-radio-group v-model="productInfo.pointerState">
          <el-radio :label="1">开启</el-radio>
          <el-radio :label="0">关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbiewr"
        >确定</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      productInfo: {
        name: '',
        productType: 1,
        productProp: 2,
        // price: '',
        price: 0,
        footTip: '',
        cornerTip: '',
        pointerState: 1
      }
    }
  },
  computed: {
    scrollWrapper() {
      return Number(this.productInfo.price) * 100
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(productInfo) {
      console.log('productInfo', productInfo)
      if (Object.keys(productInfo).length === 0) {
        console.log('对象为空')
      } else {
        console.log('对象不为空')
        this.productInfo = productInfo
      }
    },
    sumbiewr() {
      if (this.productInfo.name === '') {
        this.$message({
          type: 'error',
          message: '请输入商品名称'
        })
        return
      }
      // if (this.productInfo.price === '') {
      //   this.$message({
      //     type: 'error',
      //     message: '请输入商品金额'
      //   })
      //   return
      // }
      if (this.productInfo.price === '') {
        this.$message({
          type: 'error',
          message: '请输入赠送金币数'
        })
        return
      }
      this.$emit('ziyaecallback', this.productInfo)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.idwewr {
  width: 300px;
}
</style>
